import React from "react";

import { SaveType, postFileVersionDataJSON } from "../../../api/files";
import { DragAndDropUploadData } from "../../DragAndDropFields";
import { useUploadSheetData } from "./useUploadSheetData";

/**
 * @description JSONアップ用の関数と状態を管理
 */
export const useUploadSheetDataJSON = (
  uploadedFileList: DragAndDropUploadData[],
  setUploadedFileList: React.Dispatch<
    React.SetStateAction<DragAndDropUploadData[]>
  >,
  saveType: SaveType
) => {
  return useUploadSheetData(
    uploadedFileList,
    setUploadedFileList,
    saveType,
    postFileVersionDataJSON
  );
};
